import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PERMISSIONS } from "@/core/enums/PERMISSIONS";
import { PATH } from "@/core/constants/path";

const travelPolicyManagementMeta = {
  roles: ROLES_AND_PERMISSION_ON_ROUTES.CORPORATE_POLICY.ROLES,
  permissions: ROLES_AND_PERMISSION_ON_ROUTES.CORPORATE_POLICY.PERMISSIONS,
  listPath: PATH.CORPORATE_POLICY,
};

const myPoliciesMeta = {
  roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_POLICIES.ROLES,
  permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_POLICIES.PERMISSIONS,
  listPath: PATH.MY_POLICIES,
};

export const CorporatePolicyRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "travelPolicyManagementList",
    meta: travelPolicyManagementMeta,
    component: () =>
      import("@/modules/CorporatePolicy/views/CorporatePolicyList.vue"),
  },
  {
    path: "create",
    name: "travelPolicyManagementCreate",
    meta: {
      ...travelPolicyManagementMeta,
      permissions: [PERMISSIONS.CAN_MANAGE_ALL_TRAVEL_POLICIES],
    },
    component: () =>
      import("@/modules/CorporatePolicy/views/CorporatePolicyFormPage.vue"),
  },
  {
    path: ":id",
    name: "travelPolicyManagementView",
    meta: travelPolicyManagementMeta,
    component: () =>
      import("@/modules/CorporatePolicy/views/CorporatePolicyFormPage.vue"),
  },
];

export const MyPoliciesRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "myPolicy",
    meta: myPoliciesMeta,
    component: () => import("@/modules/CorporatePolicy/views/MyPolicy.vue"),
  },
  {
    path: ":id",
    name: "myPoliciesView",
    meta: myPoliciesMeta,
    component: () =>
      import("@/modules/CorporatePolicy/views/CorporatePolicyFormPage.vue"),
  },
];
